import { render, staticRenderFns } from "./product-overview.vue?vue&type=template&id=389ad738&"
import script from "./product-overview.vue?vue&type=script&lang=js&"
export * from "./product-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports